import {
  compose,
  setDisplayName,
  setStatic
} from 'recompose';

import {withSpark} from '@webex/react-redux-spark';
import '@webex/react-component-spark-fonts';

import {
  withInitialState,
  withBrowserGlobals,
  withIntl,
  withDataAPI,
  withRemoveWidget,
  withCurrentUser
} from './enhancers';

import './styles.css';

/**
 * Creates an enhancer HOC that provides a store and connection to Spark
 * @param {Object} options
 * @param {Object} options.reducers Map of reducers that should be used to init a Store
 * @param {Object} options.enhancers Map of enhancers that should be used to init a Store
 * @returns {Object} React Component
 */
export function constructWebexEnhancer({
  name,
  reducers,
  enhancers
}) {
  // Executes bottom to top. Bottom most HOC Will be the inner most Component
  return compose(
    // Instantiates Widgets into DOM with Data API (Must be at the top of compose)
    withDataAPI({name}),
    // Try to inject browser globals into global namespace
    withBrowserGlobals({name}),
    // Initialize state with react-redux Provider
    withInitialState({reducers, enhancers}),
    // Clears store on Remove
    withRemoveWidget,
    // Connects and Auths with Webex API
    withSpark(name),
    // Retrieves and stores current user
    withCurrentUser,
    // Set distinct display name
    setDisplayName(`WebexWidgetBase(${name})`),
    // Inject version number into component as static prop
    setStatic('version', process.env.REACT_WEBEX_VERSION)
  );
}

/**
 * Builds a Webex widget out of a React component
 * @param {String} name unique component name to inject into the global namespace
 * @param {Object} BaseComponent React Component
 * @returns {Object} React Component
 */
export default function WebexWidgetBase(name, BaseComponent) {
  return constructWebexEnhancer(name)(BaseComponent);
}

export {
  withIntl,
  withInitialState,
  withBrowserGlobals
};
